import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { verifyEmailChange } from "../services/api";

export default function VerifyEmailChange() {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");

	const didRequestRef = useRef(false);

	const [status, setStatus] = useState("loading");

	useEffect(() => {
		if (didRequestRef.current) return;
		didRequestRef.current = true;

		if (!token) {
			setStatus("invalid");
			return;
		}

		const run = async () => {
			try {
				const data = await verifyEmailChange(token);

				switch (data.code) {
					case "EMAIL_CHANGED":
						setStatus("success");
						break;
					case "EMAIL_ALREADY_CHANGED":
						setStatus("alreadyChanged");
						break;
					case "TOKEN_EXPIRED":
						setStatus("expired");
						break;
					default:
						setStatus("invalid");
				}
			} catch (err) {
				setStatus("invalid");
			}
		};

		run();
	}, [token, t]);

	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				gap: 2,
				textAlign: "center",
			}}
		>
			{status === "loading" && <CircularProgress />}

			{status === "success" && (
				<>
					<Typography variant="h5">{t("emailChanged")}</Typography>
					<Button component={Link} to="/settings" variant="contained">
						{t("goToSettings")}
					</Button>
				</>
			)}

			{status === "alreadyChanged" && (
				<>
					<Typography variant="h5">
						{t("emailAlreadyChanged")}
					</Typography>
					<Button component={Link} to="/settings" variant="contained">
						{t("goToSettings")}
					</Button>
				</>
			)}

			{status === "expired" && (
				<>
					<Typography variant="h5" color="error">
						{t("linkExpired")}
					</Typography>
					<Button component={Link} to="/settings" variant="outlined">
						{t("goToSettings")}
					</Button>
				</>
			)}

			{status === "invalid" && (
				<>
					<Typography variant="h5" color="error">
						{t("invalidOrExpiredLink")}
					</Typography>
					<Button component={Link} to="/login" variant="outlined">
						{t("loginButton")}
					</Button>
				</>
			)}
		</Box>
	);
}
